import type { Portfolio } from '@/features/bidding/types/bid'

export enum BiddingFlow {
  CAPACITY_FLOW = 'CAPACITY_FLOW',
  CAPACITY_AND_PRICE_FLOW = 'CAPACITY_AND_PRICE_FLOW',
}

const getBiddingFlow = (portfolio: Portfolio): BiddingFlow => {
  if (portfolio.countryCode.toLowerCase() === 'se' && portfolio.partnerCode === 'SE-ENTELIOS') {
    return BiddingFlow.CAPACITY_AND_PRICE_FLOW
  }
  if (['fi', 'gr', 'no'].includes(portfolio.countryCode.toLowerCase())) {
    return BiddingFlow.CAPACITY_AND_PRICE_FLOW
  }
  return BiddingFlow.CAPACITY_FLOW
}

export default getBiddingFlow
